export default {
    'project'            : 'Default constant' , 
    'margin'            : { top: 30, right: 200, bottom: 80, left: 100, top_page: 0, left_page: 0 , title_height : 70 } , 
    'api_root'          : '' , // @to be removed
    'data_version'      : '10',
    'data'      : {
        '01' : {'years_available' : [1943,2012], 'exclude_all_cancers_id' : [100], 'all_cancers_id' : 100 , 'label' : '01' },
        '10' : {'years_available' : [1943,2018], 'exclude_all_cancers_id' : [0,106], 'all_cancers_id' : 0 , 'label' : '10' }
    },
    'client_prod' : 'https://gco.iarc.who.int',
    'years_available' :[1943,2012],
    'languages' : ['en'] , 
    'all_cancers_id'    : 100 ,//55 , 
    'exclude_all_cancers_id' : [100] ,//DXX, grouped, all   
    'all_populations'   : [36,170,250,356,800,840] , //[2080,2081,2082,2083,2084] , // [0] , [2080,2081,2082,2083,2084]
    'last_year' : 2012,
    'color_no_data'   : '#7d7d80',
    'color_outmap'   : '#f0f0f0',
    'colors_types' : ['#0355a1','#d91616'], 
    'colors_sexes' : ['#3383b8','#ad027d'], 
    'colors_ages' : ["#4e79a7","#f28e2c","#e15759","#76b7b2","#59a14f","#edc949","#af7aa1","#ff9da7","#9c755f","#bab0ab","#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e","#e6ab02","#a6761d","#666666"] , 
    'colors_cohorts' : ["#4e79a7","#f28e2c","#e15759","#76b7b2","#59a14f","#edc949","#af7aa1","#ff9da7","#9c755f","#bab0ab","#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e","#e6ab02","#a6761d","#666666","#bdfdc8","#4539e0","#c2ff70","#7e73ff","#139900","#ff007b","#00b76f","#001a72","#ff7b06","#009aff","#bf0000","#00ffff","#e14f15","#6de79d","#1f004b","#66ca79","#f09bff","#008c4c","#ffaaff","#002600","#ef99d6","#002100","#ebdaff","#750000","#005f8b","#ffc065","#004355","#ff8d65","#00684d","#ff9ba4","#005341","#f7e4a2","#233200","#ffcdbc","#3c4843","#a26b00","#603630","#c8a75b","#893b00","#d88c7a"],
    'ages_start'        : [0,5,10,15,20,25,30,35,40,45,50,55,60,65,70,75,80,85], 
    'ages_labels' : ['0-4','5-9','10-14','15-19','20-24','25-29','30-34','35-39','40-44','45-49','50-54','55-59','60-64','65-69','70-74','75-79','80-84','85+'], 
    'indicators' : [
        {'key' : 'total' , 'label' : 'Numbers' } ,
        {'key' : 'total_pop' , 'label' : 'Populations' } ,
        {'key' : 'crude_rate' , 'label' : 'Crude Rate' } ,
        {'key' : 'asr' , 'label' : 'ASR (World)' } ,
        {'key' : 'asr_e' , 'label' : 'ASR (European)' } ,
        {'key' : 'asr_n' , 'label' : 'ASR (Nordic)' } ,
        {'key' : 'cum_risk' , 'label' : 'Cumulative risk' }
    ] , 
    'cum_risk_age_default': 14, 
    'isos' : {
        208 : { 'iso' : 'DNK' , 'scale' : 1250 , 'translate' :  [-120,1300] } , 
        234 : { 'iso' : 'FRO' , 'scale' : 3000 , 'translate' :  [300,3300] } ,  
        246 : { 'iso' : 'FIN' , 'scale' : 450 , 'translate' :  [-90,570] } ,  
        304 : { 'iso' : 'GRL' , 'scale' : 160 , 'translate' :  [120,260] } , 
        352 : { 'iso' : 'ISL' , 'scale' : 700 , 'translate' :  [205,850] } , 
        578 : { 'iso' : 'NOR' , 'scale' : 320 , 'translate' :  [-15,450] } , 
        752 : { 'iso' : 'SWE' , 'scale' : 450 , 'translate' :  [-40,550] }
    },
    'dataviz_filters' : {
      'hide_tab_look' : 0 , 
      'merge_tab3_to_tab2' : 0
    },
    'key_title' : 'Age Standardized Rate per 100 000 (World)' , 
    'home_graphics' : [
        { 'id' : 'svg1' ,  'asset' : 'home/isotype.svg' , 'name' : 'Infographics', 'route' : 'en/dataviz/isotype' } , 
        { 'id' : 'svg2' ,  'asset' : 'home/bubbles.svg' , 'name' : 'Bubble chart', 'route' : 'en/dataviz/bubbles?sexes=0' } , 
        { 'id' : 'svg3' ,  'asset' : 'home/bars.svg' , 'name' : 'Bar chart', 'route' : 'en/dataviz/bars' } , 
        { 'id' : 'svg4' ,  'asset' : 'home/trends.svg' , 'name' : 'Trends', 'route' : 'en/dataviz/trends?types=0&sexes=2&mode=cancer&group_populations=0&multiple_populations=0&multiple_cancers=1&cancers=20_23&populations=910&apc=cat_ca20v1.5_ca23v-1.5' }
    ]
  }